export default "| **P-11** | Decided: the planning engine stays in the browser | #1374 | Nov 1 |"